import axios from "axios";
import swal from "sweetalert";
import GlobalConfigs from "../configs/GlobalConfigs";
import * as Apis from "../apis/Apis";

export function MisFailedSubscription(datediff,trans_status,action_taken) {
    let getData = localStorage.getItem("userDetails");
    let token = JSON.parse(getData).token;
   
    const postData = {
        datediff,trans_status,action_taken
    };
    console.log('postData',postData);
    return axios({
      url: GlobalConfigs.API_URL + Apis.GET_FAILED_SUBSCRIPTION_DETAILS,
      method: "POST",
      headers: {
        ContentType: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: postData,
    });
  }
  

  export function MisFailedSubscriptionUpdate(id,message,reply_mail_date,status) {
    let getData = localStorage.getItem("userDetails");
    let token = JSON.parse(getData).token;
   
    const postData = {
      id,message,reply_mail_date,status
    };
    console.log('postData',postData);
    return axios({
      url: GlobalConfigs.API_URL + Apis.UPDATE_FAILED_SUBSCRIPTION,
      method: "POST",
      headers: {
        ContentType: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: postData,
    });
  }
  